<template>
  <v-app style="background-color: #f8f9fb">
    <!-- Diálogo de progresso -->
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title> Baixando arquivo... </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showError" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          Por favor, selecione pelo menos uma empresa.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showError = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilter" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          A Diferença entre as datas não pode ser superior a
          {{ this.dias }} dias.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilter = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilterDownload" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center"> Em Manutenção </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilterDownload = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogFinalizarPeriodo" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h5">
          <v-icon left color="warning">mdi-alert-circle</v-icon>
          Confirmar Finalização de Período
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="text-body-1">
            Deseja realmente finalizar o período de
            <strong>{{ selectedStartDate }}</strong> a
            <strong>{{ selectedEndDate }}</strong> para a empresa:
          </div>
          <div class="mt-3 text-body-1">
            <strong>{{
              selectedCompany ? selectedCompany.replace(",", "") : ""
            }}</strong>
          </div>
          <div class="mt-3 text-body-2 grey--text">
            Esta ação não poderá ser desfeita.
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-6 pb-4">
          <v-btn
            text
            @click="dialogFinalizarPeriodo = false"
            :disabled="loadingFinalizarPeriodo"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="confirmarFinalizarPeriodo"
            :loading="loadingFinalizarPeriodo"
          >
            <v-icon left>mdi-check</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogReabrirPeriodo" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h5">
          <v-icon left color="error">mdi-lock-open-variant</v-icon>
          Confirmar Reabertura de Período
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="text-body-1">
            Deseja realmente reabrir o período de
            <strong>{{ selectedStartDate }}</strong> a
            <strong>{{ selectedEndDate }}</strong> para a empresa:
          </div>
          <div class="mt-3 text-body-1">
            <strong>{{
              selectedCompany ? selectedCompany.replace(",", "") : ""
            }}</strong>
          </div>
          <div class="mt-3 text-body-2 error--text">
            <v-icon small color="error">mdi-alert</v-icon>
            Esta ação irá deletar o lote finalizado e permitirá refinalização.
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-6 pb-4">
          <v-btn
            text
            @click="dialogReabrirPeriodo = false"
            :disabled="loadingReabrirPeriodo"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="error"
            @click="confirmarReabrirPeriodo"
            :loading="loadingReabrirPeriodo"
          >
            <v-icon left>mdi-lock-open-variant</v-icon>
            Reabrir Período
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilterRegras" persistent max-width="840">
      <v-card>
        <v-card-title> Regras de Comissão </v-card-title>
        <v-card-text class="d-flex justify-center">
          <v-data-table
            :items="listagem_regras"
            :items-per-page="3"
            items-per-page-text="Linhas por página"
            class="elevation-0"
          >
            <br />
            <br />
            <br />

            <template v-slot:top>
              <v-progress-linear
                v-if="isLoading"
                indeterminate
                color="green"
              ></v-progress-linear>
            </template>

            <template v-slot:item="row">
              <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                <td colspan="100%">
                  <!-- Usar colspan="100%" para garantir que ocupe toda a linha -->
                  <div>
                    <br />
                    <strong>Regra:</strong> {{ row.item.regra }} <br />
                    <strong>Cargo:</strong>
                    {{ row.item.cargo }} &nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Empresa:</strong> {{ row.item.empresa }} <br />
                    <!-- Adicione outros campos conforme necessário -->
                    <strong>Migração :</strong>
                    {{ row.item.percentual_migracao }}% &nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Comissão:</strong> {{ row.item.percentual }}%
                    &nbsp;&nbsp;&nbsp;&nbsp; <strong>Produto:</strong>
                    {{ row.item.produto }} <br />
                    <strong>Meta de Plano:</strong>
                    {{ row.item.meta_plano }} &nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Meta de Cremação:</strong>
                    {{ row.item.meta_plano_cremacao }} &nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Meta de Jazigo:</strong> {{ row.item.meta_jazigo }}
                    <br />
                    <strong>Plano:</strong>
                    {{ row.item.plano }} &nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Modelo:</strong>
                    {{ row.item.model }} &nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Mes:</strong>
                    {{ row.item.mes }} &nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Ano:</strong> {{ row.item.ano }} <br />
                    <strong>Divisão:</strong>
                    {{ row.item.divisao }} &nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Item:</strong>
                    {{ row.item.item }} &nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>Valor Item:</strong> {{ row.item.valor_item }}
                    <br />
                    <span style="font-size: 14px"
                      >* Em caso de Venda de Migração o Percentual de Migração
                      {{ row.item.percentual_migracao }}% é calculado antes da
                      Comissão {{ row.item.percentual }}%</span
                    >
                    <br />
                    <br />
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilterRegras = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="background-color: #f8f9fb">
      <v-col cols="12">
        <filtro-component
          :opcoes="opcoes"
          :produtos="tipos_funerarios"
          :modos="modos"
          :tipos="tipos"
          :calendar="'mes'"
          @filtrar="filterData"
          @showError="showError = true"
          :title_opcao="'Campanha'"
          :campos="'N'"
        ></filtro-component>
      </v-col>
    </v-container>

    <v-row class="ml-4">
      <v-col cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="rgb(71 130 180)"
          icon="mdi-cash"
          title="Valor Distribuído"
          sub-icon-color="red"
          :valuex="false"
          :value="formatarMoeda(this.total_pago)"
          :sub-text="`Valor Recebido: ${formatarMoeda(total_valor_original)}`"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="rgb(71 130 180)"
          icon="mdi-cash"
          title="Comissão"
          sub-icon-color="red"
          :valuex="false"
          :value="formatarMoeda(this.total_pago_comissao)"
          :sub-text="'Total Pago com Comissão '"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="3" v-if="loteFinalizado">
        <base-material-lote-card
          color="rgb(71 130 180)"
          icon="mdi-lock-check"
          title="Período Finalizado"
          :competencia="loteFinalizado.competencia"
          :empresa="loteFinalizado.empresa"
          :finalizadoPor="loteFinalizado.insertBy || 'Sistema'"
          :dataFinalizacao="loteFinalizado.data_insert"
          :valorTotal="formatarMoeda(loteFinalizado.valorTotal || 0)"
          :quantidadeColaboradores="loteFinalizado.quantidadeColaboradores || 0"
          :showReopenButton="podeReabrirPeriodo"
          @reabrir-click="abrirDialogReabrirPeriodo"
        />
      </v-col>
    </v-row>

    <br />

    <v-divider></v-divider>

    <br /><br />

    <v-container
      style="background-color: #eee"
      id="financeiro"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-percent"
            title="Comissão"
            color="rgb(71 130 180)"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-data-table
              :headers="ranking_header"
              :items="lista_comissao_grupo"
              :items-per-page="20"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <br />
              <br />
              <br />

              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>

              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td
                    class="linha"
                    style="
                      width: 38%;
                      font-size: 10px;
                      font-weight: bold;
                      font-family: Verdana, Geneva, Tahoma, sans-serif;
                    "
                  >
                    <v-icon color="black" size="24" class="ml-2 mr-1">
                      <template v-if="row.item.profissao == null">
                        mdi-checkbox-blank-circle
                      </template>

                      <template
                        v-else-if="row.item.profissao === 'Telemarketing'"
                      >
                        mdi-headset
                      </template>

                      <template
                        v-else-if="
                          row.item.profissao === 'Supervisor (a)' ||
                          row.item.profissao === 'Adm' ||
                          row.item.profissao === 'Adm Comercial' ||
                          row.item.profissao === 'Supervisor (a) de Loja' ||
                          row.item.profissao.includes('Gerência') ||
                          row.item.profissao.includes('Gerente') ||
                          row.item.profissao.includes('Supervisor') ||
                          row.item.profissao.includes('Gerência Unidade') ||
                          row.item.profissao.includes(
                            'Gerência Corporativos	',
                          ) ||
                          row.item.profissao.includes('Supervisor (a)') ||
                          row.item.profissao.includes('Coordenador')
                        "
                      >
                        mdi-account-supervisor
                      </template>

                      <template
                        v-else-if="
                          row.item.profissao === 'Auxiliar' ||
                          row.item.profissao === 'Auxiliar - Interior' ||
                          row.item.profissao ===
                            'Auxiliar Administrativo/Aprendiz' ||
                          row.item.profissao === 'Assistente de Vendas' ||
                          row.item.profissao === 'Assistente administrativo' ||
                          row.item.profissao === 'Assistente' ||
                          row.item.profissao === 'Vendedor - Interior' ||
                          row.item.profissao === 'SDR' ||
                          row.item.profissao === 'Vendedor' ||
                          row.item.profissao === 'Agente funerário' ||
                          row.item.profissao.includes('Assistente')
                        "
                      >
                        mdi-clipboard
                      </template>

                      <template
                        v-else-if="
                          (row.item.profissao &&
                            row.item.profissao.startsWith('PREVIDA')) ||
                          row.item.profissao === 'Loja' ||
                          row.item.profissao === 'AM INCOOPARACOES' ||
                          row.item.profissao === 'PARQUE DAS FLORES' ||
                          row.item.profissao === 'MEMORIAL PARQUE'
                        "
                      >
                        mdi-city // Substitua 'mdi-city' pelo ícone de prédio
                        desejado
                      </template>

                      <template
                        v-else-if="
                          (row.item.profissao &&
                            row.item.profissao.startsWith('PREVIDA')) ||
                          row.item.profissao === 'Loja' ||
                          row.item.profissao === 'AM INCOOPARACOES' ||
                          row.item.profissao === 'PARQUE DAS FLORES' ||
                          row.item.profissao === 'MEMORIAL PARQUE'
                        "
                      >
                        mdi-city // Substitua 'mdi-city' pelo ícone de prédio
                        desejado
                      </template>

                      <template
                        v-else-if="
                          row.item.profissao === 'Motoboy' ||
                          row.item.profissao === 'MotoGirl'
                        "
                      >
                        mdi-motorbike
                      </template>
                      <template v-else> mdi-clipboard </template>

                      <!--
                               
                                <template v-if="row.item.tipo === 'SUPERVISOR (A)'">
                                    mdi-account-supervisor
                                  </template>

                                  <template v-else-if="typeof row.item.profissao === 'string' && ['Gerência Adjunta', 'Gerência Unidade', 'GERÊNCIA'].some(type => row.item.profissao.includes(type))">
                                    mdi-account-supervisor
                                  </template>


                                  <template v-if="
                                    row.item.profissao === 'Auxiliar' || 
                                    row.item.profissao === 'Auxiliar Administrativo/Aprendiz' || 
                                    row.item.profissao === 'Assistente de Vendas' ||
                                    row.item.profissao === 'Assistente' ||
                                    row.item.profissao === 'Vendedor PAP' ||
                                    row.item.profissao === 'Vendedor' ||
                                    row.item.profissao === 'Agente funerário'
                                  ">
                                    mdi-account
                                  </template>

                                  <template v-if="row.item.tipo === 'Adm'">
                                    mdi-account-supervisor
                                  </template>

                                  <template v-if="row.item.profissao === 'Adm'">
                                    mdi-account-supervisor
                                  </template>

                                      

                                  <template v-else-if="(row.item.profissao && row.item.profissao.startsWith('PREVIDA')) || row.item.profissao === 'AM INCOOPARACOES'">
                                    mdi-city // Substitua 'mdi-city' pelo ícone de prédio desejado
                                  </template>





                                
                                  <template v-else-if="row.item.profissao === ''">
                                    mdi-alert-circle-outline
                                  </template>

                                  -->
                    </v-icon>
                    {{ row.item.vendedor.toUpperCase() }}
                  </td>

                  <td class="linha" style="width: 22%; font-size: 14px">
                    {{
                      row.item.profissao
                        ? row.item.profissao.toUpperCase()
                        : "NÃO INFORMADO"
                    }}
                  </td>

                  <td class="linha" style="width: 12%; font-size: 14px">
                    {{
                      row.item.supervisor
                        ? row.item.supervisor.toUpperCase()
                        : "NÃO INFORMADO"
                    }}
                  </td>

                  <td class="linha" style="width: 10%; font-size: 14px">
                    <v-chip
                      :color="getStatus(row.item.empresa)"
                      text-color="white"
                    >
                      {{ row.item.empresa }}
                    </v-chip>
                  </td>

                  <td class="linha" style="width: 8%; font-size: 14px">
                    {{
                      parseFloat(row.item.valorVenda).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>

                  <td class="linha" style="width: 8%; font-size: 14px">
                    {{
                      parseFloat(row.item.comissao).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>

                  <td class="linha" style="width: 8%; font-size: 14px">
                    {{ row.item.qtd_venda }}
                  </td>
                </tr>
              </template>
            </v-data-table>
            <br />

            <div class="d-flex justify-space-between align-center">
              <div v-if="lista_comissao_grupo.length > 0 && !loteFinalizado">
                <v-btn
                  color="primary"
                  elevation="2"
                  @click="abrirDialogFinalizarPeriodo"
                >
                  <v-icon left>mdi-calendar-check</v-icon>
                  Finalizar Período
                </v-btn>
              </div>
              <div v-else></div>

              <div class="d-flex justify-end">
                <div style="width: 240px">
                  <span
                    @click="regras_download"
                    style="
                      color: purple;
                      font-size: 48px;
                      margin-right: 12px;
                      cursor: pointer;
                    "
                  >
                    <i class="fas fa-gavel"></i>
                  </span>

                  <span
                    @click="download_alelo_xls"
                    style="
                      color: orange;
                      font-size: 48px;
                      margin-right: 12px;
                      cursor: pointer;
                    "
                  >
                    <i class="fas fa-gift"></i>
                  </span>

                  <span
                    @click="download_xls"
                    style="
                      color: green;
                      font-size: 48px;
                      margin-right: 12px;
                      cursor: pointer;
                    "
                  >
                    <i class="fas fa-file-excel"></i>
                  </span>

                  <span
                    @click="exportToPDF"
                    style="
                      color: red;
                      font-size: 48px;
                      margin-right: 12px;
                      cursor: pointer;
                    "
                  >
                    <i class="fas fa-file-pdf"></i>
                  </span>

                  <br />
                </div>
              </div>
            </div>

            <br />
          </base-material-card>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
      >
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">
            Fechar
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </v-app>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import FiltroComponent from "./components/FiltroGeral.vue"; // Certifique-se de que o caminho esteja correto
import Comissao from "../../services/comissao";
import { ContentLoader } from "vue-content-loader";
import jsPDF from "jspdf";
import "jspdf-autotable";
import BaseMaterialLoteCard from "../../components/base/MaterialLoteCard.vue";

export default {
  name: "Obitos",
  components: {
    apexcharts: VueApexCharts,
    FiltroComponent,
    ContentLoader,
    BaseMaterialLoteCard,
  },

  created() {
    (this.selectedStartDate = this.getFirstDayOfMonth()),
      (this.selectedEndDate = this.formatDateBR(new Date()));

    (this.selectedStartDate2 = this.getFirstDayOfMonth()),
      (this.selectedEndDate2 = this.formatDateBR(new Date()));
  },

  // mounted() {
  //   this.carregarLoad(), this.dashboard();
  //   this.handleFilterChange(
  //     this.selectMode,
  //     this.selectedStartDate,
  //     this.selectedEndDate,
  //     this.selectedStartDate2,
  //     this.selectedEndDate2
  //   );
  // },

  computed: {
    podeReabrirPeriodo() {
      const user = JSON.parse(sessionStorage.getItem("user") || "{}");
      const roles = user.roles || [];
      return (
        roles.includes("ROLE_ADMIN") || roles.includes("ROLE_COMISSAO_REABRIR")
      );
    },
  },

  data() {
    return {
      snackbar: {
        show: false,
        text: "",
        color: "info",
        timeout: 3000,
      },
      ranking_header: [
        { text: "Vendedor", value: "vendedor" },
        { text: "Cargo", value: "profissao" },
        { text: "Supervisor", value: "supervisor" },

        { text: "Empresa", value: "empresa" },
        { text: "Valor Venda", value: "valorVenda" },
        { text: "Comissão", value: "comissao" },
      ],

      ranking_header_pdf: [
        { text: "Vendedor", value: "vendedor" },
        { text: "Cargo", value: "profissao" },
        { text: "Valor Venda", value: "valorVenda" },
        { text: "Ocorrência", value: "conformidade" },
        { text: "Comissão", value: "comissao" },
      ],

      regras_header: [
        { text: "Regras", value: "regras" },
        { text: "Cargo", value: "cargo" },

        { text: "Percentual Migraçãao", value: "percentual_migracao" },
        { text: "Percentual", value: "percentual" },
        { text: "Produto", value: "produto" },
        { text: "Meta Plano", value: "meta_plano" },
        { text: "Meta Cremação", value: "meta_cremacao" },
        { text: "Meta Jazigo", value: "meta_jazigo" },
        { text: "Plano", value: "plano" },
        { text: "Modelo", value: "modelo" },
        { text: "Mes", value: "mes" },
        { text: "Ano", value: "ano" },

        { text: "Divisão", value: "divisao" },
        { text: "Item", value: "item" },
        { text: "Valor Item", value: "valor_item" },
        { text: "Empresa", value: "empresa" },
      ],

      lista_comissao: [],
      lista_comissao_grupo: [],
      listagem_regras: [],
      dias: 0,
      produto: "Todos",
      bool_03: true,
      bool_02: true,
      showFilterRegras: false,
      total_resultado: 0,
      total_pago_comissao: 0,
      total_pago: 0,
      total_valor_original: 0,
      subTextAddDynamic: "Total Recebido:",
      recebido_acordo: 0,
      qtd_recebido_acordo: 0,
      criado_acordo: 0,
      animationInterval: null, // Intervalo para controlar a animação
      empresa: "",
      selectedCompany: "Todas",
      selectedType: "Todos",
      selectedOpcao: "Todas",
      opcoes: ["Todas", "Campanha 50 Anos"],
      selectMode: "Vencimento",
      selectedStartDate: "",
      selectedEndDate: "",
      isLoading: false,
      modos: ["Período"],
      modos2: ["SIM", "NÃO"],
      campos: "N",
      categoria: [],
      showFilter: false,
      showError: false,
      showProgress: false,
      showFilterDownload: false,
      dialogFinalizarPeriodo: false,
      loadingFinalizarPeriodo: false,
      dialogReabrirPeriodo: false,
      loadingReabrirPeriodo: false,
      loteFinalizado: null,
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "Todas",
      ],
      tipos: ["Todos"],
      tipos_funerarios: ["Todos"],

      lista_nome_empresa: [],
    };
  },

  methods: {
    isDateValid(dateString) {
      // Verifica se a string é uma data válida
      const date = new Date(dateString);
      return !isNaN(date.getTime());
    },
    areDatesValid(dates) {
      // Verifica se todas as datas na matriz são válidas
      return dates.every((dateString) => {
        const date = new Date(dateString);
        return !isNaN(date.getTime());
      });
    },

    handleFilterChange(selectedFilter, dataI, dataF, DataRI, DataRF) {
      if (selectedFilter === "Vencimento") {
        this.subTextAddDynamic = "Total Recebido: ";
      } else if (selectedFilter != "Vencimento") {
        if (
          converteDataParaFormatoISO(DataRI) <=
            converteDataParaFormatoISO(dataI) &&
          converteDataParaFormatoISO(DataRF) > converteDataParaFormatoISO(dataF)
        ) {
          this.subTextAddDynamic = "Total Recebido com Acréscimo: ";
        } else {
          this.subTextAddDynamic = "Total Recebido: ";
        }
      }
    },

    async filterData(valores) {
      this.carregarLoad(), (this.isLoading = true);
      let nova_consulta = false;

      this.selectedType =
        valores.selectedType === "Jazigo" ? "Cemitérios" : valores.selectedType;
      this.selectedOpcao = valores.selectedOpcao;
      this.selectedCompany = valores.selectedCompany.join(",");
      this.selectMode = valores.selectMode;

      this.selectMode = "Vencimento";

      this.handleFilterChange(
        valores.selectMode,
        valores.selectedStartDate,
        valores.selectedEndDate,
        valores.selectedStartDate2,
        valores.selectedEndDate2,
      );
      this.selectedStartDate = valores.selectedStartDate;
      this.selectedEndDate = valores.selectedEndDate;
      this.selectedStartDate2 = valores.selectedStartDate2;
      this.selectedEndDate2 = valores.selectedEndDate2;
      this.selectedStartDate3 = valores.selectedStartDate3;
      this.selectedEndDate3 = valores.selectedEndDate3;
      this.produto = valores.selectedProduto;

      if (
        this.selectedCompany &&
        this.selectedCompany.includes("PREVIDA") &&
        !/CEMIT[EÉ]RIO/i.test(this.selectedCompany)
      ) {
        // Verificar se periodo anterior está finalizado
        const periodoAnteriorFinalizado =
          await this.verificarLoteFinalizadoAnterior();
          console.log(periodoAnteriorFinalizado);

        if (!periodoAnteriorFinalizado) {
          // Calcular o mês anterior para exibir na mensagem
          const [dia, mes, ano] = this.selectedStartDate.split("/");
          const mesAtual = parseInt(mes);
          const anoAtual = parseInt(ano);

          let mesAnterior = mesAtual - 1;
          let anoAnterior = anoAtual;

          if (mesAnterior === 0) {
            mesAnterior = 12;
            anoAnterior = anoAtual - 1;
          }

          const competenciaAnterior = `${String(mesAnterior).padStart(
            2,
            "0",
          )}/${anoAnterior}`;

          this.showSnackbar(
            `O período anterior (${competenciaAnterior}) não foi finalizado. Finalize o período anterior antes de consultar este período.`,
            "warning",
            6000,
          );
          this.isLoading = false;
          return;
        }
      }
      // Verificar se existe lote finalizado
      await this.verificarLoteFinalizado();

      //this.gf01();
      this.dashboard();
    },

    filtrarTiposFunerarios(tipoFunerario) {
      const tiposPermitidos = "Todos";
      if (this.tipoFunerario === "Jazigo") {
        tiposPermitidos = [
          "CONCESSÃO DE COLUMBÁRIO",
          "CONCESSÃO DE JAZIGOS",
          "CONCESSÃO DE OSSÁRIO",
          "VENDA DE COLUMBÁRIO",
          "VENDA DE JAZIGOS - IMEDIATO",
          "VENDA DE JAZIGOS - PREVENTIVO",
          "VENDA DE JAZIGOS - TRANSITÓRIO",
        ];
      }
      if (this.tipoFunerario === "Plano") {
        tiposPermitidos = [
          "COMPLETO",
          "FAMILIA",
          "INTEGRAL",
          "P23",
          "TOTAL",
          "PF - AMPARO",
          "PROTEÇÃO",
          "PV - AMIGO",
          "PV - BRONZE",
          "PV - CREMAÇÃO COM CERIMÔNIA",
          "PV - DIAMANTE",
          "PV - EMPRESARIAL",
          "PV - EMPRESARIAL - EMPRESA",
          "PV - ESPECIAL",
          "PV - ESMERALDA",
          "PV - ESSENCIAL",
          "PV - IDEAL",
          "PV - MAIOR",
          "PV - MAIS",
          "PV - MASTER GOLD",
          "PV - MELHOR",
          "PV - PLANO PJ",
          "PV - PLUS",
          "PV - POLICIA MILITAR",
          "PV - PRATA",
          "PV - PREVIDA",
          "PV - PREVIPARQ DO AGRESTE",
          "PV - RUBI",
          "PV - SÃO MATHEUS",
        ];
      }

      if (this.tipoFunerario === "Cremação") {
        tiposPermitidos = [
          "CREMAÇÃO",
          "CREMAÇÃO COM CERIMÔNIA",
          "CREMAÇÃO SEM CERIMÔNIA",
          "URNAS CINERARIAS",
        ];
      }

      if (
        this.tipoFunerario === "Todos" ||
        this.tipoFunerario === "Funerária" ||
        this.tipoFunerario === "Serviços Administrativos e Cemiteriais" ||
        this.tipoFunerario === "Serviços Cemiteriais"
      ) {
        tiposPermitidos = ["Todos"];
      }

      if (tiposPermitidos.includes(tipoFunerario)) {
        return true; // Mantém apenas os tipos permitidos
      } else {
        return false; // Remove os tipos não permitidos
      }
    },

    exportToPDF() {
      const empresas = [
        "PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "CEMITÉRIO PREVIDA",
      ];
      const usuario = JSON.parse(sessionStorage.getItem("user")).nome;
      const maxLinesPerPage = 18; // Limite de linhas por página

      const logoY = 15;
      const logoWidth = 150;
      const logoHeight = 80;
      const titleY = 35;
      const periodY = titleY + 20;

      // Preparar informações de rodapé
      const now = new Date();
      const formattedDate = now.toLocaleDateString("pt-BR");
      const formattedTime = now.toLocaleTimeString("pt-BR");
      const dateTimeString = `Data e Hora de Criação: ${formattedDate} ${formattedTime}`;

      // Calcula o total de comissões para a empresa selecionada (para todas as empresas)
      const totalComissaoEmpresaSelecionada = this.lista_comissao_grupo
        .filter(
          (item) =>
            item.empresa_colaborador === this.selectedCompany &&
            parseFloat(item.comissao || 0) > 0,
        )
        .reduce((acc, item) => acc + parseFloat(item.comissao || 0), 0);

      // Calcula o total de vendas para outras empresas (diferentes da selecionada)
      const totalVenda_outra = this.lista_comissao_grupo
        .filter(
          (item) =>
            item.empresa_colaborador !== this.selectedCompany &&
            parseFloat(item.comissao || 0) > 0,
        )
        .reduce((acc, item) => acc + parseFloat(item.comissao || 0), 0);

      // Calcula o total geral (soma dos dois totais)
      const totalGeral = totalComissaoEmpresaSelecionada + totalVenda_outra;

      empresas.forEach((empresa) => {
        // Filtra os dados para a empresa atual
        const filteredData = this.lista_comissao_grupo
          .filter(
            (item) =>
              item.empresa_colaborador === empresa &&
              parseFloat(item.comissao || 0) > 0,
          )
          .sort((a, b) => {
            return a.vendedor.localeCompare(b.vendedor, "pt", {
              sensitivity: "base",
            });
          })
          .map((item) =>
            this.ranking_header_pdf.map((header) => {
              let value = item[header.value];
              if (
                header.value === "valorVenda" ||
                header.value === "comissao"
              ) {
                return parseFloat(value || 0).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                });
              } else if (header.value === "profissao") {
                return value ? value.toUpperCase() : ""; // Aplica toUpperCase() em profissao
              }
              return value !== null && value !== undefined ? value : "";
            }),
          );

        // Usando os totais já calculados anteriormente

        // Se filteredData está vazio, pula para a próxima empresa
        if (filteredData.length === 0) return;

        // Inicia a criação do PDF
        const doc = new jsPDF("landscape", "pt", "a4");
        let startY = periodY + 40;
        const headers = [
          ...this.ranking_header_pdf.map((header) => header.text),
          "Anotações",
        ];

        // Determinar logo baseado na empresa
        const logoPath = this.determinarLogo(empresa);

        const addTableToPDF = (data, isFirstPage) => {
          doc.autoTable({
            startY: startY,
            head: [headers],
            body: data,
            theme: "grid",
            headStyles: {
              fillColor: [41, 128, 185],
              textColor: [255, 255, 255],
            },
            columnStyles: { 0: { cellWidth: "auto" } },
            margin: { bottom: 60 },
            didDrawPage: (data) => {
              // Adicionar logo no topo de cada página
              if (logoPath) {
                try {
                  doc.addImage(
                    logoPath,
                    "PNG",
                    20,
                    logoY,
                    logoWidth,
                    logoHeight,
                  );
                } catch (error) {
                  console.error("Erro ao adicionar logo:", error);
                }
              }

              // Adiciona o título e o período na parte superior de cada página
              doc.setFontSize(16);
              doc.setFont("helvetica", "bold");
              doc.text(
                `Comissão de Venda - ${empresa}`,
                doc.internal.pageSize.width / 2,
                titleY,
                { align: "center" },
              );

              doc.setFontSize(12);
              doc.setFont("helvetica", "normal");
              doc.text(
                "Período: " +
                  this.selectedStartDate +
                  " até " +
                  this.selectedEndDate,
                doc.internal.pageSize.width / 2,
                periodY,
                { align: "center" },
              );

              // Adicionar rodapé em cada página
              const pageHeight = doc.internal.pageSize.height;
              doc.setFontSize(10);
              doc.setFont("helvetica", "normal");
              doc.text(dateTimeString, 20, pageHeight - 30);
              doc.text("Usuário: " + usuario, 20, pageHeight - 15);
            },
          });
        };

        for (let i = 0; i < filteredData.length; i += maxLinesPerPage) {
          const pageData = filteredData.slice(i, i + maxLinesPerPage);
          const isFirstPage = i === 0;

          addTableToPDF(pageData, isFirstPage);
          startY = doc.autoTable.previous.finalY + 20;

          if (i + maxLinesPerPage < filteredData.length) {
            doc.addPage();
            startY = periodY + 40; // Mesma posição inicial da primeira página
          }
        }

        const totalPagoY = startY + 20;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(`Total Pago ${this.selectedCompany} :`, 20, totalPagoY);

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");
        doc.text(
          `R$ ${totalComissaoEmpresaSelecionada.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          220,
          totalPagoY,
        );

        const totalOutrasY = totalPagoY + 20;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text("Total Pago (Outras empresas) :", 20, totalOutrasY);

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");
        doc.text(
          `R$ ${totalVenda_outra.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          220,
          totalOutrasY,
        );

        const totalGeralY = totalOutrasY + 20;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text("Total Geral :", 20, totalGeralY);

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");
        doc.text(
          `R$ ${totalGeral.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          220,
          totalGeralY,
        );

        doc.save(
          `${this.selectedStartDate}_${empresa}_lista_comissao_venda.pdf`,
        );
      });
    },

    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1,
      );
      return this.formatDateBR(primeiroDiaDoMes);
    },

    startAnimation(targetValue) {
      this.animationInterval = setInterval(() => {
        if (this.animatedValue < targetValue) {
          this.animatedValue += 1; // Atualiza o valor animado
        } else {
          clearInterval(this.animationInterval); // Interrompe a animação quando atingir o valor desejado
        }
      }, 10); // Intervalo em milissegundos entre cada atualização
    },

    formatDateBR(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },

    formatDateBRAPI(date) {
      if (!date) return "";
      const parsedDate = new Date(this.formatDateBR(date));
      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      return `${year}-${month}-${day}`;
    },

    carregarLoad() {
      this.bool_03 = true;
      this.bool_03 = true;
    },

    async dashboard() {
      this.isLoading = true;

      this.selectMode = "Vencimento";
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate,
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);

      const formattedStartDate2 = converteDataParaFormatoISO(
        this.selectedStartDate2,
      );
      const formattedEndDate2 = converteDataParaFormatoISO(
        this.selectedEndDate2,
      );

      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate,
      );

      if (diferencaEmDias > 365) {
        this.isLoading = false;
        this.showFilter = true;
        this.showProgress = false;
        this.dias = 365;
        return;
      }

      Comissao.lista_comissao_venda(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "Todos",
        this.selectedOpcao,
        this.produto,
      )
        .then((response) => {
          if (response.status === 200) {
            this.lista_comissao = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.calcularDadosPorUsuario();
          this.isLoading = false;
        });
    },

    download_alelo_xls() {
      this.showProgress = true;
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate,
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);
      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate,
      );

      if (diferencaEmDias > 90) {
        this.isLoading = false;
        this.showFilter = true;
        this.dias = 90;
        return;
      }

      Comissao.lista_comissao_venda_alelo_xls(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "Todos",
        this.selectedOpcao,
        this.produto,
      )
        .then((response) => {
          if (response.status === 200) {
            // Defina o nome do arquivo zip, se a resposta for um ZIP
            const fileName = `comissao_${Date.now()}.zip`;

            // Cria um URL temporário para o arquivo binário
            const fileURL = window.URL.createObjectURL(
              new Blob([response.data]),
            );

            // Cria o link de download
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", fileName);

            // Adiciona o link à página e simula o clique para baixar
            document.body.appendChild(fileLink);
            fileLink.click();

            // Remove o link da página após o download
            document.body.removeChild(fileLink);
          }
        })
        .catch((error) => {
          console.error("Erro ao baixar o arquivo:", error);
        })
        .finally(() => {
          this.showProgress = false;
        });
    },

    download_xls() {
      this.showProgress = true;
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate,
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);
      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate,
      );

      if (diferencaEmDias > 90) {
        this.isLoading = false;
        this.showFilter = true;
        this.dias = 90;
        return;
      }

      Comissao.lista_comissao_venda_xls(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "Todos",
        this.selectedOpcao,
        this.produto,
      )
        .then((response) => {
          if (response.status === 200) {
            const fileName = `comissao_${Date.now()}.xlsx`;
            const fileURL = window.URL.createObjectURL(
              new Blob([response.data]),
            );
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
          }
        })
        .catch((error) => {
          // Lida com erros
          console.error("Erro ao baixar o arquivo Excel:", error);
        })
        .finally(() => {
          // Após o término do download, oculte o diálogo de progresso
          this.showProgress = false;
        });
    },

    regras_download() {
      this.showFilterRegras = true;
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);

      Comissao.lista_regras(formattedEndDate, this.selectedCompany)
        .then((response) => {
          if (response.status === 200) {
            this.listagem_regras = response.data;
          }
        })
        .catch((error) => {
          // Lida com erros
          console.error("Erro ao baixar o arquivo Excel:", error);
        })
        .finally(() => {});
    },

    calcularDadosPorUsuario() {
      const dadosPorUsuario = {};
      this.lista_comissao_grupo = "";
      this.total_pago_comissao = 0;
      this.total_pago = 0;
      this.total_valor_original = 0;
      this.total_resultado = 0;
      const vendasSomadas = new Set();

      this.lista_comissao.forEach((item) => {
        const idVendedor = item.id_vendedor;
        if (idVendedor === 0) {
          return;
        }

        if (!dadosPorUsuario.hasOwnProperty(idVendedor)) {
          dadosPorUsuario[idVendedor] = {
            comissao: 0,
            empresa: "",
            valorVenda: 0,
            pago: 0,
            resultado: 0,
            comissaofinal: 0,
          };
        }

        //dadosPorUsuario[idVendedor].comissao += item.comissao;
        dadosPorUsuario[idVendedor].vendedor = item.vendedor;
        dadosPorUsuario[idVendedor].tipoVenda = item.tipoVenda;
        dadosPorUsuario[idVendedor].comissao += item.comissao;
        dadosPorUsuario[idVendedor].empresa = item.empresa;
        dadosPorUsuario[idVendedor].qtd_venda = item.qtd_venda;
        dadosPorUsuario[idVendedor].valorVenda += item.valorVenda;
        dadosPorUsuario[idVendedor].profissao = item.profissao;
        dadosPorUsuario[idVendedor].supervisor = item.supervisor;
        dadosPorUsuario[idVendedor].empresa_colaborador =
          item.empresa_colaborador;
        dadosPorUsuario[idVendedor].conformidade = item.conformidade;

        //this.total_resultado += item.qtd_venda;

        if (item.profissao == "") {
          dadosPorUsuario[idVendedor].comissao = 0;
        }

        this.total_pago_comissao += item.comissao;
        this.total_pago += item.valorVenda;
        if (!vendasSomadas.has(item.idVenda)) {
          vendasSomadas.add(item.idVenda);
          this.total_valor_original += Number(item.valorOriginal || 0);
        }
        dadosPorUsuario[idVendedor].comissaofinal += item.comissao;
      });

      this.lista_comissao_grupo = Object.values(dadosPorUsuario);
    },

    formatarMoeda(valor) {
      // Verifica se o valor é numérico
      if (isNaN(valor)) {
        return "Valor inválido";
      }

      // Formata o valor como moeda brasileira (BRL)
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    getStatus(status) {
      // Convert status to uppercase to make the comparison case insensitive
      const normalizedStatus = status.toUpperCase();

      switch (normalizedStatus) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "CEMITERIO PREVIDA SÃO MIGUEL":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";

        default:
          "success";
      }
    },

    calcularComissao: function (empresa, resultado, comissao, original, pago) {
      if (empresa === "PREVIDA") {
        if (resultado < 0) {
          // Se o resultado for negativo, retorna a diferença entre pago e original
          return pago - original;
        } else {
          // Se o resultado não for negativo, retorna a comissão
          return comissao;
        }
      } else {
        // Se a empresa for diferente de "Previda", retorna a comissão
        return comissao;
      }
    },

    calcularDiferencaEntreDatas(dataInicial, dataFinal) {
      const data1 = new Date(dataInicial);
      const data2 = new Date(dataFinal);

      // Verifique se as datas são válidas
      if (isNaN(data1) || isNaN(data2)) {
        return NaN; // Retorna NaN se uma das datas for inválida
      }

      const diferencaEmMilissegundos = data2 - data1;
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

      return diferencaEmDias;
    },

    clear() {
      this.$refs.form.reset();
    },

    determinarLogo(empresa) {
      empresa = empresa.replace(",", "");
      try {
        switch (empresa) {
          case "PREVIDA":
            return require("@/assets/logo_previda.png");
          case "PARQUE DAS FLORES":
            return require("@/assets/parque_logo.png");
          case "PARQUE DO AGRESTE":
            return require("@/assets/am_logo.png");
          case "MEMORIAL PARQUE MACEIÓ":
            return require("@/assets/memorial_logo.png");
          case "CEMITERIO PREVIDA":
          case "CEMITÉRIO PREVIDA":
          case "CEMITERIO PREVIDA SÃO MIGUEL":
            return require("@/assets/versan_logo.png");
          default:
            return require("@/assets/logo_grupo.png");
        }
      } catch (error) {
        console.error("Erro ao carregar logo:", error);
        return null;
      }
    },

    showSnackbar(text, color = "info", timeout = 3000) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.timeout = timeout;
      this.snackbar.show = true;
    },

    async verificarLoteFinalizadoAnterior() {
      if (!this.selectedCompany || this.selectedCompany === "Todas") {
        return true;
      }

      if (!this.selectedStartDate || !this.selectedEndDate) {
        return true;
      }

      try {
        // Calcular o mês anterior
        const [dia, mes, ano] = this.selectedStartDate.split("/");
        const mesAtual = parseInt(mes);
        const anoAtual = parseInt(ano);

        let mesAnterior = mesAtual - 1;
        let anoAnterior = anoAtual;

        if (mesAnterior === 0) {
          mesAnterior = 12;
          anoAnterior = anoAtual - 1;
        }

        const competenciaAnterior = `${String(mesAnterior).padStart(
          2,
          "0",
        )}/${anoAnterior}`;

        const response = await Comissao.buscarLoteIncluindoTodos(
          competenciaAnterior,
          "VENDAS",
          this.selectedCompany,
        );
        console.log("[lote anterior] ok", {
          competenciaAnterior,
          empresa: this.selectedCompany,
          status: response.status,
          data: response.data,
        });

        // Se encontrou o lote do mês anterior, significa que está finalizado
        if (response.data) {
          return true;
        } else {
          // Não encontrou lote finalizado do mês anterior
          return false;
        }
      } catch (error) {
        console.log("[lote anterior] erro", {
          empresa: this.selectedCompany,
          temResponse: !!error.response,
          status: error.response?.status,
          data: error.response?.data,
          message: error.message,
        });
        if (error.response && error.response.status === 404) {
          // Não encontrou lote finalizado do mês anterior
          return false;
        } else {
          console.error("Erro ao verificar lote finalizado anterior:", error);
          // Em caso de erro, permitir continuar
          return true;
        }
      }
    },

    async verificarLoteFinalizado() {
      if (!this.selectedCompany || this.selectedCompany === "Todas") {
        this.loteFinalizado = null;
        return;
      }

      if (!this.selectedStartDate || !this.selectedEndDate) {
        this.loteFinalizado = null;
        return;
      }

      try {
        const competencia = this.converterParaCompetencia(
          this.selectedStartDate,
        );
        const response = await Comissao.buscarLote(
          competencia,
          "VENDAS",
          this.selectedCompany,
        );

        if (response.data) {
          this.loteFinalizado = response.data;
        } else {
          this.loteFinalizado = null;
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.loteFinalizado = null;
        } else {
          console.error("Erro ao verificar lote finalizado:", error);
          this.loteFinalizado = null;
        }
      }
    },

    converterParaCompetencia(data) {
      const partes = data.split("/");
      if (partes.length === 3) {
        const [dia, mes, ano] = partes;
        return `${mes}/${ano}`;
      }
      return null;
    },

    formatarDataHora(dataISO) {
      if (!dataISO) return "-";
      const data = new Date(dataISO);
      return data.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    abrirDialogFinalizarPeriodo() {
      if (!this.selectedCompany || this.selectedCompany === "Todas") {
        this.showError = true;
        return;
      }

      if (!this.selectedStartDate || !this.selectedEndDate) {
        this.showSnackbar("Por favor, selecione um período.", "warning");
        return;
      }

      if (this.loteFinalizado) {
        this.showSnackbar(
          "Este período já está finalizado. Use a opção 'Reabrir Período' se necessário.",
          "warning",
          5000,
        );
        return;
      }

      this.dialogFinalizarPeriodo = true;
    },

    abrirDialogReabrirPeriodo() {
      if (!this.podeReabrirPeriodo) {
        this.showSnackbar(
          "Você não tem permissão para reabrir períodos.",
          "error",
          5000,
        );
        return;
      }

      this.dialogReabrirPeriodo = true;
    },

    async confirmarFinalizarPeriodo() {
      this.loadingFinalizarPeriodo = true;

      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate,
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);

      try {
        const response = await Comissao.finalizarPeriodo(
          this.selectedCompany,
          formattedStartDate,
          formattedEndDate,
          "VENDAS",
        );

        this.loadingFinalizarPeriodo = false;
        this.dialogFinalizarPeriodo = false;
        this.showSnackbar("Período finalizado com sucesso!", "success");

        // Recarregar informações do lote
        await this.verificarLoteFinalizado();
      } catch (error) {
        this.loadingFinalizarPeriodo = false;
        console.error("Erro ao finalizar período:", error);

        if (error.response && error.response.status === 403) {
          const errorMessage = error.response.data;
          if (
            typeof errorMessage === "string" &&
            errorMessage.startsWith(
              "Você não tem permissão para finalizar comissões do tipo:",
            )
          ) {
            this.showSnackbar(errorMessage, "error", 5000);
            return;
          }
        }

        if (error.response && error.response.status === 400) {
          const errorMessage = error.response.data;
          if (
            typeof errorMessage === "string" &&
            errorMessage.includes("já finalizado")
          ) {
            this.showSnackbar(errorMessage, "warning", 5000);
            await this.verificarLoteFinalizado();
            return;
          }
        }

        this.showSnackbar(
          "Erro ao finalizar período. Tente novamente.",
          "error",
        );
      }
    },

    async confirmarReabrirPeriodo() {
      this.loadingReabrirPeriodo = true;

      try {
        const competencia = this.converterParaCompetencia(
          this.selectedStartDate,
        );
        const response = await Comissao.reabrirPeriodo(
          competencia,
          "VENDAS",
          this.selectedCompany,
        );

        this.loadingReabrirPeriodo = false;
        this.dialogReabrirPeriodo = false;

        if (response.data && !response.data.erro) {
          this.showSnackbar("Período reaberto com sucesso!", "success");
          this.loteFinalizado = null;
        } else {
          this.showSnackbar(
            response.data?.mensagem || "Erro ao reabrir período.",
            "error",
          );
        }
      } catch (error) {
        this.loadingReabrirPeriodo = false;
        console.error("Erro ao reabrir período:", error);

        const errorMessage =
          error.response?.data?.mensagem ||
          error.response?.data ||
          "Erro ao reabrir período. Tente novamente.";
        this.showSnackbar(errorMessage, "error");
      }
    },
  },
};

function formatMoeda(value) {
  // Use o método toLocaleString com a opção style: 'currency' para formatar como moeda

  if (value === undefined || value === null) {
    return "R$ 0,00"; // Ou você pode retornar 0 como número, se preferir.
  }

  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  //return 0
  //return value
}

function converteDataParaFormatoISO(dataNoFormatoBR) {
  const partes = dataNoFormatoBR.split("/");
  if (partes.length === 3) {
    const [dia, mes, ano] = partes;
    return `${ano}-${mes}-${dia}`;
  }
  return null; // Retorna null se a data estiver em um formato inválido
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

/* Defina uma classe para preencher a largura horizontalmente e centralizar verticalmente */
.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}
/* Centralize horizontalmente */
.justify-center {
  justify-content: center;
}

.gray-row {
  background-color: #e7f1ff; /* ou qualquer outra cor cinza que você preferir */
}
.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important; /* Desativa a transição de cor */
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}
.card-container {
  display: flex;
  justify-content: space-around; /* ou outro alinhamento que desejar */
}
</style>
